import React, { useMemo } from 'react';
import { usePostMessageListener } from '../../util/entity-provider/usePostMessageListener';

const prefixMessageKeys = (messages, appId = 'app') => {
  return Object.keys(messages).reduce((acc, messageKey) => {
    acc[`${appId}__${messageKey}`] = messages[messageKey];
    return acc;
  }, {});
};

export const useMergeMessages = messages => {
  const [appMessages, setAppMessages] = React.useState();
  const [appId, setAppId] = React.useState();

  const mergedMessages = useMemo(() => {
    if (appMessages && appId) {
      return Object.keys(appMessages).reduce(
        (acc, language) => {
          const prefixed = prefixMessageKeys(appMessages[language], appId);
          acc[language] = { ...(acc[language] || {}), ...(prefixed || {}) };
          return acc;
        },
        { ...(messages || {}) }
      );
    }

    return messages;
  }, [appMessages, appId, messages]);

  const listener = React.useCallback(message => {
    if (message?.type === 'messages') {
      setAppMessages(message.messages);
      setAppId(message.appId);
    }
  }, []);

  usePostMessageListener(listener);

  return mergedMessages;
};
